module.exports = __webpack_public_path__ + "static/media/historyImage.1da7e55d.jpg";